import Swal from "sweetalert2";
import { api } from "../api/Middleware";
import { AI_AGENTS_URL, AI_URL, AI_AGENTS_TEST_URL, WABOTTY_URL, ACCOUNT_FEATURES_URL } from "../api/Urls";
import { ERROR_MESSAGES } from "../helpers/ErrorMessages";
import { updateAgent } from "./AgentsServices";

export const GetAccounts = async () => {
  try {
    let response = await api.get(
      `${WABOTTY_URL}get_all_sessions/`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const SyncActions = async (payload) => {
  try {
    let response = await api.post(`${WABOTTY_URL}sync_actions/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const ConnectWhatsappAccount = async (params) => {
  try {
    let response = await api.post(`${WABOTTY_URL}connect_account/`, params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};
export const ReconnectWhatsappAccount = async (params) => {
  try {
    let response = await api.post(`${WABOTTY_URL}reconnect_account/`, params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};
export const GetWhatsappQrCode = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}generate_qr_code/`, data, {
      responseType: "arraybuffer",
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const GetTemplates = async (params) => {
  try {
    let response = await api.get(`${WABOTTY_URL}get_templates/` + params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const PauseOrActiveAccount = async (data) => {
  try {
    let response = await api.post(
      `${WABOTTY_URL}pause_or_active_account/`,
      data
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

/**
 * Pausa/reativa as RESPOSTAS do agente sem desligar a sessão.
 *
 * Diferente de PauseOrActiveAccount (que para a sessão inteira), este
 * mantém a sessão online — mensagens continuam chegando à Central de
 * Atendimento, apenas as respostas automáticas são desligadas.
 *
 * @param {Object} data - { phone, paused: bool }
 */
export const SetAgentPaused = async (data) => {
  try {
    const response = await api.post(
      `${WABOTTY_URL}set_agent_paused/`,
      data,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error.response || error;
  }
};

export const DeleteAccount = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}delete_account/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const CheckAccountStatus = async (phone, agentId = null) => {
  try {
    let response = await api.post(`${WABOTTY_URL}get_session_status/`, {
      phone: phone
    });
    if (response.status === 200) {
      // Verificar se o status está como "WORKING"
      if (response.data?.status === "WORKING") {
        // Se o status for WORKING e temos um agentId, atualizar o agente com wabotty_account
        if (agentId && phone) {
          try {
            await updateAgent(agentId, {
              wabotty_account: phone
            });
            console.log("Agente atualizado com wabotty_account:", phone);
          } catch (updateError) {
            console.error("Erro ao atualizar agente com wabotty_account:", updateError);
            // Não interromper o fluxo principal por erro na atualização
          }
        }
        
        return {
          connected: true,
          data: response.data
        };
      } else {
        // Status não está como "WORKING", mostrar Swal e recarregar página
        // Swal.fire({
        //   title: "Sessão não está ativa",
        //   text: "Sua sessão do WhatsApp não está funcionando. Por favor, realize a conexão novamente.",
        //   icon: "info",
        //   confirmButtonText: "Entendi",
        //   confirmButtonColor: "var(--primary)",
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     window.location.reload();
        //   }
        // });
        
        return {
          connected: false,
          data: response.data,
          message: "Sessão não está ativa"
        };
      }
    }
  } catch (error) {
    if (error.response?.status === 404) {
      return {
        connected: false,
        message: error.response.data?.message || "Conta não encontrada"
      };
    }
    throw error.response;
  }
};

export const RequestWhatsappCode = async (phone, method = null) => {
  try {
    const payload = { phone };
    if (method) {
      payload.method = method;
    }

    let response = await api.post(`${WABOTTY_URL}request_whatsapp_code/`, payload);
    
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        session: response.data.session,
        phone: response.data.phone,
        message: response.data.message,
        code: response.data.code,
        method: response.data.method
      };
    }
  } catch (error) {
    console.error("Erro ao solicitar código WhatsApp:", error);
    
    // Tratamento de erros baseado na função DRF com suporte a códigos de erro WAHA
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          return {
            success: false,
            error: data.error || "Parâmetro inválido",
            error_code: data.error_code,
            suggestion: data.suggestion,
            status: status
          };
        case 404:
          return {
            success: false,
            error: data.error || "Sessão não encontrada",
            error_code: data.error_code,
            suggestion: data.suggestion,
            status: status
          };
        case 500:
          // Tratamento específico para erros 500 com códigos WAHA
          const errorCode = data.error_code;
          let userFriendlyError = data.error || "Erro interno do servidor";
          let suggestion = data.suggestion || "Tente novamente em alguns minutos.";

          // Mapear códigos de erro específicos para mensagens mais amigáveis
          switch (errorCode) {
            case "SESSION_DISCONNECTED":
              userFriendlyError = data.error || "A sessão WhatsApp foi desconectada ou expirou";
              suggestion = data.suggestion || "Reinicie a sessão WhatsApp. Vá em 'Contas WhatsApp' e reconecte sua conta.";
              break;
            case "SESSION_NOT_FOUND":
              userFriendlyError = data.error || "Sessão WhatsApp não encontrada";
              suggestion = data.suggestion || "Crie uma nova conexão WhatsApp em 'Contas WhatsApp'.";
              break;
            case "QR_CODE_REQUIRED":
              userFriendlyError = data.error || "É necessário escanear o QR Code primeiro";
              suggestion = data.suggestion || "Acesse 'Contas WhatsApp' e escaneie o QR Code para autenticar.";
              break;
            case "BROWSER_ERROR":
              userFriendlyError = data.error || "Erro interno do navegador WhatsApp";
              suggestion = data.suggestion || "Tente novamente em alguns minutos. Se persistir, reinicie a sessão.";
              break;
            default:
              // Para códigos não mapeados, usar valores do backend ou padrão
              userFriendlyError = data.error || "Erro interno do servidor";
              suggestion = data.suggestion || "Tente novamente em alguns minutos.";
              break;
          }

          return {
            success: false,
            error: userFriendlyError,
            error_code: errorCode,
            suggestion: suggestion,
            status: status
          };
        default:
          return {
            success: false,
            error: data.error || `Erro ${status}`,
            error_code: data.error_code,
            suggestion: data.suggestion,
            details: data.details,
            status: status
          };
      }
    }
    
    return {
      success: false,
      error: "Erro de conexão",
      status: 500
    };
  }
};


export const AddAutoReply = async (payload, setNotify) => {
  try {
    let formData = new FormData();

    // Preenche o FormData com os dados
    for (let key in payload) {
      if (key === "media") {
        formData.append("file", payload.media); // arquivo no campo "file"
      } else {
        formData.append(key, payload[key]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await api.post(
      `${WABOTTY_URL}add_auto_reply/`,
      formData,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar resposta automática", error);
    if (setNotify) {
      setNotify({
        title: "Erro!",
        message: "Erro ao cadastrar resposta automática.",
        type: "danger",
        visible: true,
      });
    }
  }
};

export const UpdateAutoReply = async (payload, setNotify) => {
  try {
    let formData = new FormData();

    // Preenche o FormData com os dados
    for (let key in payload) {
      if (key === "media") {
        formData.append("file", payload.media); // arquivo no campo "file"
      } else {
        formData.append(key, payload[key]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await api.put(
      `${WABOTTY_URL}update_auto_reply/`,
      formData,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar resposta automática", error);
    if (setNotify) {
      setNotify({
        title: "Erro!",
        message: "Erro ao atualizar resposta automática.",
        type: "danger",
        visible: true,
      });
    }
  }
};

export const DeleteActionBulk = async (uid, data, setNotify) => {
  try {
    let ids = [];
    data.map((action) => ids.push(action.id));

    let response = await api.delete(WABOTTY_URL + "delete_actions_bulk/", {
      data: { uid: uid, ids: ids },
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Operação realizada com sucesso!",
        type: "success",
        visible: true,
      });
      return true;
    }
  } catch (error) {
    console.log(error);
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  }
};

export const UpdateTemplate = async (params, setNotify) => {
  try {
    let response = await api.put(`${WABOTTY_URL}update_template/`, params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
    return false;
  }
};

export const UpdateAiAgentData = async (params, setNotify) => {
  try {
    let response = await api.put(`${WABOTTY_URL}update_agent_data/`, params);
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Agente atualizado com sucesso!",
        type: "success",
        visible: true,
      });
      return true;
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message:
        error?.response?.data?.error ||
        "Ocorreu um erro, por favor, tente novamente em alguns minutos. Se o erro persistir, contacte nosso suporte.",
      type: "error",
      visible: true,
    });
    return false;
  }
};

export const GetAgentsData = async (page = 1, pageSize = 10, search = "") => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });

    if (search) {
      params.append("search", search);
    }

    let response = await api.get(`${AI_AGENTS_URL}?${params}`);
    if (response.status === 200) {
      return response.data; // Retorna toda a estrutura: {results, count, next, previous, total_pages, current_page}
    }
  } catch (error) {
    throw error.response;
  }
};

// Atualizar API Key do agente
export const UpdateAgentApiKey = async (agentId, apiKey, model = null, setNotify) => {
  try {
    const payload = {
      api_key: apiKey,
    };
    
    if (model) {
      payload.model = model;
    }
    
    let response = await api.patch(
      `${AI_AGENTS_URL}${agentId}/update_api_key/`,
      payload
    );
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: "Configurações atualizadas com sucesso!",
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message: error?.response?.data?.error || "Erro ao atualizar configurações",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Atualizar status do agente (ativo/inativo)
export const UpdateAgentStatus = async (agentId, isActive, setNotify) => {
  try {
    let response = await api.patch(
      `${AI_AGENTS_URL}${agentId}/update_status/`,
      {
        is_active: isActive,
      }
    );
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: `Agente ${isActive ? "ativado" : "desativado"} com sucesso!`,
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao atualizar status do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Atualizar versão ativa do agente
export const UpdateAgentVersion = async (agentId, versionActive, setNotify) => {
  try {
    let response = await api.patch(
      `${AI_AGENTS_URL}${agentId}/update_version/`,
      {
        version_active: versionActive,
      }
    );
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: `Versão alterada para v.${versionActive} com sucesso!`,
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao atualizar versão do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Buscar versões disponíveis do agente
export const GetAgentVersions = async (agentId) => {
  try {
    let response = await api.get(
      `${AI_AGENTS_URL}${agentId}/available_versions/`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Preparar agente para teste


// Buscar estatísticas do agente
export const GetAgentStats = async (agentId) => {
  try {
    let response = await api.get(`${AI_AGENTS_URL}${agentId}/stats/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Registrar cópia do prompt (para analytics)
export const RegisterPromptCopy = async (agentId) => {
  try {
    let response = await api.post(`${AI_AGENTS_URL}${agentId}/copy_prompt/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    // Não lançar erro aqui, pois é apenas para analytics
    return false;
  }
};

// Criar nova versão do agente
export const CreateAgentVersion = async (agentId, setNotify) => {
  try {
    let response = await api.post(`${AI_AGENTS_URL}${agentId}/create_version/`);
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: "Nova versão criada com sucesso!",
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao criar nova versão do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

// Exportar versão específica do agente
export const ExportAgentVersion = async (agentId, version = null) => {
  try {
    const params = version ? `?version=${version}` : "";
    let response = await api.get(
      `${AI_AGENTS_URL}${agentId}/export_version/${params}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Buscar todas as versões do agente
export const GetAgentVersionHistory = async (agentId) => {
  try {
    let response = await api.get(`${AI_AGENTS_URL}${agentId}/versions/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Buscar detalhes de uma versão específica
export const GetAgentVersionDetail = async (agentId, version) => {
  try {
    let response = await api.get(
      `${AI_AGENTS_URL}${agentId}/version_detail/?version=${version}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Ativar/desativar agente (método alternativo)
export const ToggleAgentStatus = async (agentId, setNotify) => {
  try {
    let response = await api.post(`${AI_AGENTS_URL}${agentId}/activate/`);
    if (response.status === 200) {
      if (setNotify) {
        setNotify({
          title: "Sucesso!",
          message: response.data.message,
          type: "success",
          visible: true,
        });
      }
      return response.data;
    }
  } catch (error) {
    if (setNotify) {
      setNotify({
        title: "Oops!",
        message:
          error?.response?.data?.error || "Erro ao alterar status do agente",
        type: "error",
        visible: true,
      });
    }
    throw error.response;
  }
};

export const CreateUser = async (data) => {
  try {
    let response = await api.post(WABOTTY_URL, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const ActiveBot = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}active_bot/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const PauseBot = async (data) => {
  try {
    let response = await api.post(`${WABOTTY_URL}pause_bot/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const ChangeBotStatus = async (data, setShowModal, loadColumns) => {
  try {
    let response = await api.post(`${AI_URL}enable_or_disable/`, data);
    
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error)
    if (error.response.status === 404) {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        html: `Este contato ainda não esta cadastrado, deseja cadastrá-lo agora?`,
        showCancelButton: true,
        confirmButtonColor: "var(--primary)",
        cancelButtonColor: "var(--dark)",
        confirmButtonText: "Cadastrar agora",
        cancelButtonText: "Cancelar",
      }).then((value) => {
        if (value.isConfirmed) {
          if (setShowModal && loadColumns) {
            setShowModal(true);
            loadColumns();
          }
        }
      });
    } else {
      Swal.fire(
        "Oops!",
        "Ocorreu um erro inesperado! Por favor, tente novamente ou entre em contato com nosso suporte.",
        "error"
      );
    }
  }
};

export const GetContacts = async (page = 1, phone = false) => {
  try {
    let response = await api.get(
      `${WABOTTY_URL}get_contacts/?page=${page}${
        phone ? `&phone=${phone}` : ""
      }`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const SearchContact = async (phone) => {
  try {
    let response = await api.get(
      `${WABOTTY_URL}search_contact/?phone=${phone}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const UpdateContactName = async (payload) => {
  try {
    let response = await api.put(`${WABOTTY_URL}update_contact_name/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const getBotStatus = async (phone) => {
  try {
    const params = new URLSearchParams({ phone: phone });
    let response = await api.get(`${AI_URL}get_bot_status?${params}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Erro ao buscar status do bot:", error);
    return false;
  }
};

export const getWhatsappProfile = async (session) => {
  try {
    const params = new URLSearchParams({ session: session });
    let response = await api.get(`${WABOTTY_URL}get_profile/?${params}`);
    if (response.status === 200) {
      return {
        success: true,
        data: response.data
      };
    }
  } catch (error) {
    console.error("Erro ao buscar perfil do WhatsApp:", error);
    
    // Tratar diferentes tipos de erro baseado no status
    if (error.response) {
      const { status, data } = error.response;
      return {
        success: false,
        error: data.error || "Erro desconhecido",
        status: status
      };
    }
    
    return {
      success: false,
      error: "Erro de conexão",
      status: 500
    };
  }
};

// Função para vincular/desvincular agente da sessão WAHA
export const updateSession = async (phone, type, agentId = null) => {
  try {
    const payload = {
      phone: phone,
      type: type
    };

    // Adicionar agent_id apenas para operação "link"
    if (type === "link" && agentId) {
      payload.agent_id = agentId;
    }

    let response = await api.put(`${WABOTTY_URL}update_session/`, payload);
    
    if (response.status === 200) {
      return {
        success: true,
        data: response.data
      };
    }
  } catch (error) {
    console.error("Erro na operação de sessão:", error);
    
    // Tratar diferentes tipos de erro baseado no status
    if (error.response) {
      const { status, data } = error.response;
      return {
        success: false,
        error: data.error || "Erro desconhecido",
        status: status,
        data: data
      };
    }
    
    return {
      success: false,
      error: "Erro de conexão",
      status: 500
    };
  }
};

// Função para resetar a memória do agente para um contato específico
export const resetAgentMemory = async (uid, phone, agent_id, account_id) => {
  try {
    const payload = {
      uid: uid,
      phone: phone,
      message: "resetar",
      agent_id: agent_id,
      account_id: account_id
    };

    let response = await api.post(`${AI_AGENTS_TEST_URL}`, payload);

    if (response.status === 200) {
      return {
        success: true,
        data: response.data
      };
    }

    // Fallback case - se chegou aqui mas não entrou no if acima
    return {
      success: false,
      error: `Status inesperado: ${response.status}`,
      status: response.status
    };
  } catch (error) {
    console.error("Erro ao resetar memória do agente:", error);

    // Tratar diferentes tipos de erro baseado no status
    if (error.response) {
      const { status, data } = error.response;
      return {
        success: false,
        error: data.error || "Erro desconhecido",
        status: status,
        data: data
      };
    }

    return {
      success: false,
      error: "Erro de conexão",
      status: 500
    };
  }
};

// Função para verificar uso restante da feature WhatsApp (feature_id = 10)
export const GetWhatsappFeatureUsage = async () => {
  try {
    let response = await api.get(`${ACCOUNT_FEATURES_URL}?simple=1&feature=10`);

    if (response.status === 200) {
      // A API retorna um array com a feature filtrada
      const features = response.data;

      if (Array.isArray(features) && features.length > 0) {
        const whatsappFeature = features[0];
        return {
          success: true,
          usage_remaining: whatsappFeature.usage_remaining,
          feature_name: whatsappFeature.name,
          feature_id: whatsappFeature.id,
          data: whatsappFeature
        };
      }

      // Feature não encontrada
      return {
        success: false,
        error: "Feature WhatsApp não encontrada",
        usage_remaining: 0
      };
    }
  } catch (error) {
    console.error("Erro ao verificar uso da feature WhatsApp:", error);

    if (error.response) {
      const { status, data } = error.response;
      return {
        success: false,
        error: data.error || "Erro ao verificar limite de conexões",
        status: status,
        usage_remaining: 0
      };
    }

    return {
      success: false,
      error: "Erro de conexão",
      status: 500,
      usage_remaining: 0
    };
  }
};
